import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { MainService } from './main.service';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userSubject = new BehaviorSubject<any>(null);
  public user$ = this.userSubject.asObservable();

  constructor(private mainService: MainService) {}

  loadUser(): Observable<any> {
    // If user data exists, return it without making API call
    if (this.userSubject.value) {
      return of(this.userSubject.value);
    }

    // If no data exists, make the API call
    return this.mainService.getUser().pipe(
      tap(user => this.userSubject.next(user)),
      map(user => user)
    );
  }

  getUser(): Observable<any> {
    return this.user$;
  }

  getCurrentUser(): any {
    return this.userSubject.value;
  }

  // Method to force refresh user data
  refreshUser(): Observable<any> {
    return this.mainService.getUser().pipe(
      tap(user => this.userSubject.next(user)),
      map(user => user)
    );
  }

  // Clear user data on logout
  clearUser(): void {
    this.userSubject.next(null);
  }
}